import ReactDOM from "react-dom";
import classes from "./InfoWrapper.module.css";
import util from "../../../styles/utilities.module.css";
const InfoWrapper = ({ modalProps }) => {
  const { isOpen, description, setIsOpen } = modalProps;
  const closeModal = () => {
    setIsOpen(false);
  };

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={`${classes["modal-overlay"]} ${util.modalOverlay}`}>
      <div className={`${classes.modal} ${util['surface']}`}>
  <button onClick={closeModal} className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']} ${classes.crossBtn}`} aria-label="Close info dialog">
          ✕
        </button>
        <h4 className={classes.body}>{description}</h4>
      </div>
    </div>,
    document.body
  );
};

export default InfoWrapper;
